import { RouteHelpers } from '@/mixins';
import { Tools } from '@/types';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ToolsDashboard = () => import(/* webpackChunkName: "tools" */ '@/views/tools/ToolsDashboard.vue');
const ProcessLeaver = () =>
  import(
    /* webpackChunkName: "ProcessLeaver" */
    '@/views/tools/leaversTool/ProcessLeaver.vue'
  );
const LeaverHistoryLog = () =>
  import(
    /* webpackChunkName: "LeaverHistoryLog" */
    '@/views/tools/leaversTool/LeaverHistoryLog.vue'
  );
const LockMaintenance = () =>
  import(
    /* webpackChunkName: "LockMaintenance" */
    '@/views/tools/systemTools/LockMaintenance.vue'
  );
const ClearCacheSettings = () =>
  import(
    /* webpackChunkName: "ClearCacheSettings" */
    '@/views/tools/systemTools/ClearCacheSettings.vue'
  );
const ToolsTreeView = () => import(/* webpackChunkName: "tools-tree" */ '@/components/tools/TreeView.vue');
const ProcessLeaverHistory = () => import(/* webpackChunkName: "ProcessLeaverHistory" */ '@/views/tools/leaversTool/ProcessLeaverHistory.vue');
const DealDocumentCopy = () =>
  import(
    /* webpackChunkName: "DealCopyRequest" */
    '@/views/tools/automotive/dealDocumentCopy/request/dealCopyRequest.vue'
  );
const DealDocumentHistory = () =>
  import(
    /* webpackChunkName: "DealCopyHistory" */
    '@/views/tools/automotive/dealDocumentCopy/history/dealCopyHistory.vue'
  );
const DocumentRetention = () => import('@/views/tools/DocumentRetention.vue');
const ExceptionalJobs = () => import('@/views/tools/ExceptionalJobs.vue');
const GenerateExceptionalJob = () => import('@/views/tools/ExceptionalJobs/GenerateExceptionalJob.vue');

const meta = {
  layout: 'TreeView',
  treeViewKey: TreeViewConstants.Keys.Tools,
  title: 'Tools'
};

export const ToolsRoutes = [
  {
    ...Tools.DocumentRetention,
    components: {
      default: DocumentRetention,
      treeView: ToolsTreeView
    },
    meta: {
      ...meta,
      treePath: 'documentRetention'
    }
  },
  {
    ...Tools.DealCopyRequest,
    components: {
      default: DealDocumentCopy,
      treeView: ToolsTreeView
    },
    meta: {
      ...meta,
      treePath: 'dealCopyRequest'
    }
  },
  {
    ...Tools.DealCopyHistory,
    components: {
      default: DealDocumentHistory,
      treeView: ToolsTreeView
    },
    meta: {
      ...meta,
      treePath: 'dealCopyHistory'
    }
  },
  {
    ...Tools.ProcessLeaver,
    components: {
      default: ProcessLeaver,
      treeView: ToolsTreeView
    },
    meta: {
      ...meta,
      treePath: 'processLeaver'
    }
  },
  {
    ...Tools.ProcessLeaverHistory,
    components: {
      default: ProcessLeaverHistory,
      treeView: ToolsTreeView
    },
    meta: {
      ...meta,
      treePath: 'processLeaverHistory'
    }
  },
  {
    ...Tools.LeaverHistoryLog,
    components: {
      default: LeaverHistoryLog,
      treeView: ToolsTreeView
    },
    props: {
      default: true
    },
    meta: {
      ...meta,
      treePath: 'leaverHistoryLog'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Tools.LeaverHistoryLog.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['leaverId']);
    }
  },
  {
    ...Tools.LockMaintenance,
    components: {
      default: LockMaintenance,
      treeView: ToolsTreeView
    },
    meta: {
      ...meta,
      treePath: 'lockMaintenance'
    }
  },
  {
    ...Tools.ClearCacheSettings,
    components: {
      default: ClearCacheSettings,
      treeView: ToolsTreeView
    },
    meta: {
      ...meta,
      treePath: 'clearCacheSettings'
    }
  },
  {
    ...Tools.Base,
    components: {
      default: ToolsDashboard,
      treeView: ToolsTreeView
    },
    meta
  },
  {
    ...Tools.GenerateExceptionalJob,
    components: {
      default: GenerateExceptionalJob,
      treeView: ToolsTreeView
    },
    meta
  },
  {
    ...Tools.ExceptionalJobs,
    components: {
      default: ExceptionalJobs,
      treeView: ToolsTreeView
    },
    meta
  }
];
